
import HttpClient from '../HttpService';

function findOrCreate(data) {
    return HttpClient.post('/pdis/find-or-create', data);
}

function update(id, data) {
    return HttpClient.put(`/pdis/${id}`, data);
}

function destroy(payload) {
	return HttpClient.delete('/pdis', { data: payload });
}

function exportPresenceReport(pdiId, formId) {
    return HttpClient.get(`/pdis/${pdiId}/presence-report/${formId}`);
}

export default {
	destroy,
	update,
    findOrCreate,
    exportPresenceReport
}
